import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';

// Utils

import { internationalizeList } from '@utils/miscellaneous/internationalizeList';



const MandatorySeekingForCoverageModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        environment: {
            links: {
                DASHBOARD
            }
        },
        modalHeaderProps
    } = props;

    const handleDashboardClick = () => {
        window.location = DASHBOARD;
    };

    const handleHideClick = () => hideAllModals();

    const getParagraphs = () => {

        const ids = [
            'modals.mandatory_seeking_for_coverage.at_least_one',
            'modals.mandatory_seeking_for_coverage.click_close',
            'modals.mandatory_seeking_for_coverage.click_dashboard'
        ];

        return internationalizeList(ids, 'p');

    };

    return (
        <Fragment>
            <ModalHeader
                {...{
                    ...modalHeaderProps,
                    hideModal: hideAllModals
                }}
                closeAllModals
                hideAllModals={hideAllModals}
            />
            <div className="gi-modal__body txt-left" id = 'mandatorySeekingForCoverageModal'>
                { getParagraphs() }
            </div>
            <div className="gi-modal__controls">
                <Button
                    className="usa-button usa-button--outline gi-button gi-button__outline"
                    onClick={handleHideClick}
                >
                    <FormattedMessage id='button.close'/>
                </Button>
                <Button
                    className="usa-button gi-button gi-button__primary"
                    onClick={handleDashboardClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.dashboard'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default MandatorySeekingForCoverageModal;
